import { createFileRoute, redirect } from '@tanstack/react-router';
import { type ApiReferencePackageStructure, mapPackageData } from '../../../../../features/docs/api-reference/deref-cache';
import { ApiReferenceLayout } from '../../../../../features/docs/api-reference/layout/api-reference-layout';

const stableEmptyArrayRef = [] as const satisfies ApiReferencePackageStructure[];

export const Route = createFileRoute('/docs/_layout/api-reference/_provider/$package')({
  loader: async ({ context, location, params, preload }) => {
    if (!context.apiSourceData) {
      return undefined;
    }

    const packageName = decodeURIComponent(params.package).split('?')[0].split('#')[0];
    const matchingPackage = context.apiSourceData.packages?.find((pkg) => pkg.name === packageName);
    if (!matchingPackage || matchingPackage.hidden) {
      if (!preload) {
        throw redirect({ to: '/docs/api-reference', search: location.search });
      }

      return undefined;
    }

    return mapPackageData(
      context.bundle,
      context.apiSourceData.metadata.registryVersion,
      context.apiSourceData.metadata.version,
      context.apiSourceData.metadata.builtAt,
      matchingPackage,
      context.apiSourceData.schemas,
    );
  },
  preload: true,
  shouldReload: true,
  component: DocsApiReferencePackage,
});

function DocsApiReferencePackage() {
  const { dereferencedPackage, structure } = Route.useLoaderData() || {};

  return (
    // Key is important here to update the container ref in `ApiReferenceLayout` for scroll tracking
    <ApiReferenceLayout dereferencedPackage={dereferencedPackage} key={dereferencedPackage?.name} structure={structure || stableEmptyArrayRef} />
  );
}
